import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { CooperativeHousingShareTransaction } from '../../model/Transfer/cooperative-housing-share-transaction';
import { LeaseAgreementForm } from '../../model/lease-agreement-form';
import { CooperativeHousingTransferService } from '../../service/data/cooperative-housing-transfer.service';

@Component({
    selector: 'app-transfer-list',
    templateUrl: './transfer-list.component.html',
    styleUrls: ['./transfer-list.component.scss'],
    providers: [CommandDispatcher, CooperativeHousingTransferService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransferListComponent extends CommandController implements OnInit {
  constructor(
    handlerResolver: CommandHandlerResolver,
    columnDefinitionFactory: ColumnDefinitionFactory,
    private _navService: NavigationService,
    private _service: CooperativeHousingTransferService,
    private fb: FormBuilder,
    private fcf: FormControlExFactory,
    commandDispatcher: CommandDispatcher
  ) {
    super(commandDispatcher, handlerResolver);
    this.columnDefinition = [
      columnDefinitionFactory.createDate('LEASE_AGREEMENT.AGREEMENT_DATE', 'transferDate'),
      columnDefinitionFactory.create('COOPERATIVE_HOUSING.OWNER', 'name'),
      columnDefinitionFactory.createNumber('COOPERATIVE_HOUSING.TRANSFERRED_SHARE', 'share'),
      columnDefinitionFactory.createNumber('COOPERATIVE_HOUSING.OWNED_SHARE', 'resultingShare'),
      columnDefinitionFactory.create('COOPERATIVE_HOUSING.TRANSFER_TYPE', 'transferType'),
    ];
  }

  @Input() rentalObjectId: string;
  itemsSource: CooperativeHousingShareTransaction[];

  private _isNew: boolean;
  columnDefinition: ColumnDefinition[];
  menuDefinition: MenuItemDefinition[] = [];
  selectedRow: LeaseAgreementForm;

  onRowClicked(e: { context: CooperativeHousingShareTransaction; event: any }) {
    this._navService.navigate(['brf-transfers', 'edit', e.context.transferId], null, e.event.ctrlKey);
  }

  createTransfer() {
    this._navService.navigate(['brf-transfers', 'pre-transfer', this.rentalObjectId]);
  }

  ngOnInit() {
    this.AddSubscription(this._service.getObjectTransactions(this.rentalObjectId).subscribe(res => (this.itemsSource = res)));
  }
}
